import styled from "styled-components";
import { H3, P } from "@/lib/styles";
import { ButtonUnboxedPrimary } from "@/lib/styles/buttons";

export const JobApplicationContainer = styled.div`
  display: flex;
  flex-direction: column;

  width: 100%;
  ${({ theme }) => theme.mediaQueries.laptop} {
    width: 50%;
  }
`;

export const Heading = styled(H3)``;
export const Excerpt = styled(P)`
  margin-top: 24px;
`;
export const ApplicationLink = styled(ButtonUnboxedPrimary)`
  color: ${({ theme }) => theme.colors.red};
`;
